import { render, staticRenderFns } from "./DropdownMenuContent.vue?vue&type=template&id=3b739f71&"
import script from "./DropdownMenuContent.vue?vue&type=script&lang=js&"
export * from "./DropdownMenuContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports